import React, { useEffect, useState } from 'react';
import style from './SigninWithAppleButton.module.css';
import { Capacitor } from '@capacitor/core';
import { Button } from 'lincd-mui-base/components/Button';
import { cl } from 'lincd/utils/ClassNames';
import { useAuth } from 'lincd-auth/hooks/useAuth';
export const SigninWithAppleButton = ({ label = 'Sign in with Apple', // default text button
scopes = 'email name', // Apple web accepts email/name scopes
className, // additional CSS classNames to apply to the button
onCallback, // callback function invoked when the authentication is successful.
onLoadingChange, // callback function invoked when the loading state changes, you can pass a function to handle the loading state when call the server
restProps, firebaseConfig, }) => {
    const [appleSignInModule, setAppleSignInModule] = useState(null);
    const [loading, setLoading] = useState(false); // loading spinner
    const auth = useAuth();
    const platform = Capacitor.getPlatform();
    const isSupportedPlatform = platform === 'ios' || platform === 'web';
    useEffect(() => {
        // Dynamically import the module inside useEffect
        if (isSupportedPlatform) {
            import('@capacitor-community/apple-sign-in')
                .then((module) => {
                setAppleSignInModule(module);
            })
                .catch((error) => {
                console.error('Error importing module:', error);
            });
        }
    }, [isSupportedPlatform]);
    const signInWithApple = () => {
        if (!appleSignInModule) {
            console.warn('Apple Sign-In is not ready yet');
            return;
        }
        setLoading(true);
        const { SignInWithApple } = appleSignInModule;
        const currentLocation = typeof window !== 'undefined'
            ? `${window.location.origin}${window.location.pathname}`
            : '';
        const clientId = platform === 'web'
            ? process.env.APPLE_SIGN_IN_CLIENT_ID ||
                process.env.APPLE_WEB_CLIENT_ID ||
                process.env.APP_ID
            : process.env.APP_ID;
        const redirectURI = platform === 'web'
            ? process.env.APPLE_SIGN_IN_REDIRECT_URI || currentLocation
            : process.env.APPLE_SIGN_IN_REDIRECT_URI || '';
        if (!clientId) {
            setLoading(false);
            console.warn('Missing Apple Sign-In client ID');
            return;
        }
        const options = {
            clientId,
            redirectURI,
            scopes: scopes,
            nonce: 'nonce',
        };
        SignInWithApple.authorize(options)
            .then((result) => {
            if (result && result.response && result.response.identityToken) {
                if (onLoadingChange) {
                    onLoadingChange(true);
                }
                auth
                    .signinOAuth('apple', result.response)
                    .then((response) => {
                    if (response === null || response === void 0 ? void 0 : response.error) {
                        setLoading(false);
                        if (onLoadingChange) {
                            onLoadingChange(false);
                        }
                    }
                    if (onCallback) {
                        onCallback(response);
                    }
                })
                    .catch((err) => {
                    setLoading(false);
                    if (onLoadingChange) {
                        onLoadingChange(false);
                    }
                    console.error('signin with apple failed:', err);
                });
                return;
            }
            setLoading(false);
            if (onLoadingChange) {
                onLoadingChange(false);
            }
        })
            .catch((err) => {
            setLoading(false);
            if (onLoadingChange) {
                onLoadingChange(false);
            }
            console.warn('signin with apple error', err);
        });
    };
    if (!isSupportedPlatform) {
        return null;
    }
    return (React.createElement(Button, { className: cl(style.root, className), onClick: signInWithApple, variant: "outlined", fullWidth: true, disabled: loading, startIcon: React.createElement("svg", { className: style.icon, viewBox: "-1.5 0 20 20" },
            React.createElement("path", { d: "M11.570887 3.19296C12.29996 2.34797 12.791401 1.17098 12.656912 0c-1.050633.04-2.321706.67099-3.075048 1.51498-.67649.74899-1.267029 1.94597-1.10827 3.09396 1.171976.08699 2.36822-.57 3.097293-1.41598m2.6281 7.43189C14.22831 13.65181 16.969663 14.65879 17 14.67179c-.022246.071-.437848 1.43498-1.443988 2.84496-.87064 1.21799-1.773639 2.43097-3.196392 2.45697-1.397473.025-1.847455-.79399-3.446157-.79399-1.59769 0-2.09722.76799-3.419865.81899-1.373205.049-2.419793-1.31798-3.2965-2.53196C.403236 14.98379-.966935 10.44985.873442 7.3899c.914121-1.51898 2.547203-2.48197 4.320842-2.50597 1.347924-.025 2.62102.86899 3.445145.86899s2.371256-1.07499 3.99726-.91699c.680534.027 2.591695.263 3.818276 1.98397-.099097.059-2.280247 1.27499-2.255979 3.80495", fillRule: "evenodd" })), ...restProps }, label));
};
//# sourceMappingURL=SigninWithAppleButton.js.map